import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl, defaultEnquiryMessage } from "@/utilities/whatsapp";
import { trackEvent, AnalyticsEvents } from "@/utilities/analytics";

export default function AnnouncementBar() {
    const href = buildWhatsAppUrl(defaultEnquiryMessage);
    return (
        <div
            className="w-full bg-cs-charcoal text-white text-[12px] font-mono uppercase tracking-[0.18em] cs-corrugated overflow-hidden"
            data-testid="announcement-bar"
        >
            <div className="cs-container flex items-center justify-center md:justify-between gap-4 py-2 min-w-0">
                <span className="hidden md:inline text-white/60 shrink-0">
                    <span className="inline-block w-2 h-2 bg-cs-orange mr-2 align-middle cs-pulse-dot"></span>
                    Singapore · Since 2010 · MK Holdings Pte Ltd
                </span>
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                        trackEvent(AnalyticsEvents.WHATSAPP_CLICK, { source: "announcement-bar" })
                    }
                    className="inline-flex items-center gap-2 text-white hover:text-cs-orange transition-colors min-w-0 flex-1 md:flex-none justify-center md:justify-start"
                    data-testid="announcement-whatsapp-link"
                >
                    <MessageCircle className="w-3.5 h-3.5 shrink-0" strokeWidth={2} />
                    <span className="truncate">
                        <span className="md:hidden">WhatsApp Us for Container Availability</span>
                        <span className="hidden md:inline">New, Used & Customised Containers — WhatsApp Us for Current Availability</span>
                    </span>
                </a>
            </div>
        </div>
    );
}
